import { SupplementaryMaterialsPanel } from 'components/supplementary_materials/SupplementaryMaterialsPanel';

export interface TabSupplementarMaterialProps {
  classroomId: string;
}

export const TabSupplementarMaterial = ({
  classroomId
}: TabSupplementarMaterialProps) => (
  <SupplementaryMaterialsPanel
    parentKind="classroom"
    parentReference={classroomId}
    variant="complementary"
  />
);
